export const DEFAULT_BUCKET_INFO = {
  bucket: 'cdb-m-default-bucket',
  tenantIdForTest: 'mss_75eba3ca18e440f9bac5cf53a48c5acd',
  tenantIdForProd: 'mss_76c9ad6a0ad841d8a1f59c5d0c2a1c2d',
};

export const DEFAULT_SIGNATURE_URL = '/apigw/api/upload/get-post-token';

export const ACCOUNT_ROLE = {
  Primary: 1, //  主账号
  Bypass: 2, //  子账号
};
